import {
    ClipboardDocumentIcon,
    ClipboardDocumentListIcon,
    ArrowDownTrayIcon,
    ArrowUpTrayIcon,
    ArrowLeftIcon,
} from '../../automationStudioIcons';
import { AutoSuggest } from '../../../FormComponent';
import ButtonComponent from '../../../customButton';
import {
    filterOptions,
    getNoOptionsText,
    getOptionLabel,
    getOptionValue,
    isOptionEqualToValue,
    renderOption,
} from '../../../AutomationStudio/utils/optionHelpers';
import StateIndicator from './StateIndicator';
import styles from '../../../../styles/automationStudio/automationStudio.module.scss';
import { LABELS } from '../../content';

export default function RightPanelToolbar({
    state,
    selectedStep,
    instructions,
    isExecuting,
    testCompleted,
    testCaseKey,
    replayExecuting,
    replayCurrentStepIndex,
    flatStepsForReplay,
    onBackToInstructions,
    selectedTestCaseId,
    onTestCaseChange,
    optionsWithLoading,
    isLoadingTestCases,
    testCaseApiError,
    testCaseOptions,
    onTestCaseInputChange,
    onTestCaseDropdownScroll,
    onTestCaseKeyboardNavigation,
    hasInstructions,
    showEmptyRightPanel = false,
    onCopyInstructions,
    onPasteInstructions,
    canImport,
    onImportClick,
    canExport,
    onExport,
    isNlpAutomated = false,
    isExportBusy = false,
    canUploadFile,
    onUploadClick,
}) {
    const showInstructionActions = state === 'INSTRUCTIONS_VIEW';

    return (
        <div className={styles.stateIndicatorRow}>
            <div className={styles.stateIndicatorLeftCluster}>
                <StateIndicator
                    state={state}
                    selectedStep={selectedStep}
                    instructions={instructions}
                    isExecuting={isExecuting}
                    testCompleted={testCompleted}
                    testCaseKey={testCaseKey}
                    replayExecuting={replayExecuting}
                    replayCurrentStepIndex={replayCurrentStepIndex}
                    flatStepsForReplay={flatStepsForReplay}
                />
                {state === 'EXECUTION_VIEW' && isExecuting && onBackToInstructions && (
                    <ButtonComponent
                        ctaText={LABELS.INSTRUCTIONS}
                        variant="primary"
                        size="small"
                        className="white bg-primary"
                        startIcon={<ArrowLeftIcon className="icon white" style={{ width: 14, height: 14 }} />}
                        onClick={onBackToInstructions}
                        type="button"
                        tooltip={LABELS.INSTRUCTIONS}
                    />
                )}
            </div>
            <div className={styles.stateIndicatorActions}>
                <div className={styles.headerTestCaseSelector}>
                    <AutoSuggest
                        name="automationStudioTestCase"
                        label="Select Test Case"
                        size="small"
                        value={selectedTestCaseId || ""}
                        disabled={isExecuting}
                        onChange={onTestCaseChange}
                        options={optionsWithLoading}
                        loading={isLoadingTestCases}
                        noOptionsText={getNoOptionsText(isLoadingTestCases, testCaseOptions.length, testCaseApiError)}
                        getOptionLabel={getOptionLabel}
                        getOptionValue={getOptionValue}
                        isOptionEqualToValue={isOptionEqualToValue}
                        filterOptions={filterOptions}
                        renderOption={(option, params) => renderOption(option, params, getOptionLabel)}
                        onInputChange={onTestCaseInputChange}
                        onDropdownScroll={onTestCaseDropdownScroll}
                        onKeyboardNavigation={onTestCaseKeyboardNavigation}
                        openOnFocus
                        allowClear
                        notifyInputChangeOnClear
                    />
                </div>
                {showInstructionActions && hasInstructions && onCopyInstructions && (
                    <ButtonComponent
                        variant="secondary"
                        size="small"
                        className="slate900 bg-slate50"
                        startIcon={<ClipboardDocumentIcon className="icon slate900" style={{ width: 14, height: 14 }} />}
                        onClick={onCopyInstructions}
                        disabled={isExecuting}
                        type="iconbutton"
                        tooltip="Copy instruction"
                    />
                )}
                {(showEmptyRightPanel || (showInstructionActions && !hasInstructions)) &&
                    onPasteInstructions && (
                    <ButtonComponent
                        variant="secondary"
                        size="small"
                        className="slate900 bg-slate50"
                        startIcon={<ClipboardDocumentListIcon className="icon slate900" style={{ width: 14, height: 14 }} />}
                        onClick={onPasteInstructions}
                        disabled={isExecuting}
                        type="iconbutton"
                        tooltip="Paste instruction"
                    />
                )}
                <span
                    title={canImport ? "Import instructions and plan from a JSON file" : "Reset or clear the workspace first to import"}
                    className={styles.tooltipHost}
                >
                    <ButtonComponent
                        ctaText="Import"
                        variant="outline"
                        className="primary"
                        size="small"
                        startIcon={<ArrowUpTrayIcon className="icon" style={{ width: 14, height: 14 }} />}
                        onClick={onImportClick}
                        disabled={!canImport}
                    />
                </span>
                <span
                    title={
                        canExport
                            ? 'Export saved plan as JSON (from server)'
                            : isExportBusy
                              ? 'Export unavailable while generating, replaying, or saving'
                              : !isNlpAutomated
                                ? 'Only NLP automated test cases can export a plan'
                                : 'Save or open a test case to export'
                    }
                    className={styles.tooltipHost}
                >
                    <ButtonComponent
                        ctaText="Export"
                        variant="outline"
                        className="primary"
                        size="small"
                        startIcon={<ArrowDownTrayIcon className="icon" style={{ width: 14, height: 14 }} />}
                        onClick={onExport}
                        disabled={!canExport}
                    />
                </span>
                <span title="Upload file" className={styles.tooltipHost}>
                    <ButtonComponent
                        ctaText="Upload file"
                        variant="outline"
                        className="primary"
                        size="small"
                        startIcon={<ArrowUpTrayIcon className="icon" style={{ width: 14, height: 14 }} />}
                        onClick={onUploadClick}
                        disabled={!canUploadFile}
                    />
                </span>
            </div>
        </div>
    );
}
